module.exports = __webpack_public_path__ + "static/media/pacrim2.8ab1497b.jpg";